import { render } from "./hrm-leave-allocate-modal.vue?vue&type=template&id=3b5c3559&scoped=true"
import script from "./hrm-leave-allocate-modal.vue?vue&type=script&lang=js"
export * from "./hrm-leave-allocate-modal.vue?vue&type=script&lang=js"

import "./hrm-leave-allocate-modal.vue?vue&type=style&index=0&id=3b5c3559&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5c3559"]])

export default __exports__